import "../../../assets/style/featuresStyle/useInfor.scss";
import {
  IconArrowBottom,
  IconChangePass,
  IconLogout,
  IconUser,
} from "../../../assets/icon";
import TranslateText from "../TranslateText";
import { memo, useState } from "react";
import { logOut } from "../../../services/slice/AuthSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import { setOpenModalChangePassWord } from "../../../services/slice/AccountSlice";
import { useSelector } from "react-redux";
import { accountSelector } from "../../../services/selector/index.";
import ModalChangePassWord from "../Modal/other/ModalChangePassWord";

const User = ({ handleSetShow, mini }) => {
  const [show, setShow] = useState(false);
  const stateAcc = useSelector(accountSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRef = useRef();
  const handleLogout = () => {
    dispatch(logOut());
    localStorage.removeItem("accessToken");
    localStorage.removeItem("keyMenu");
    return navigate("/login");
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShow(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(userRef);
  return (
    <div className="wrapperUserInfo">
      {stateAcc.isOpenModalChangePassWord ? <ModalChangePassWord /> : null}
      <div className="iconAvatar" ref={userRef}>
        <span className="user" onClick={() => setShow((pre) => !pre)}>
          <IconUser />
          <span className="iconArrow">
            <IconArrowBottom />
          </span>
        </span>
        <ul
          style={{ display: `${show ? "block" : "none"}` }}
          className="userActions"
        >
          <li className="listItem">
            <IconUser />
            <span>{localStorage.getItem("userInfor")}</span>
            <hr />
          </li>
          <li
            className="listItem"
            onClick={() => {
              setShow(false);
              dispatch(setOpenModalChangePassWord(true));
            }}
          >
            <IconChangePass width={20} height={20} />
            <span>
              <TranslateText text={"Đổi mật khẩu"} />
            </span>
          </li>
          <li className="listItem" onClick={handleLogout}>
            <IconLogout width={20} height={20} />
            <span>
              <TranslateText text={"Đăng xuất"} />
            </span>
          </li>
        </ul>
      </div>

      {!mini ? (
        <>
          <p>
            <TranslateText text={"Xin chào"} />{" "}
            <span>{localStorage.getItem("userInfor")}</span>
          </p>
        </>
      ) : null}
    </div>
  );
};

export default memo(User);
